import { render, staticRenderFns } from "./JustificationList.vue?vue&type=template&id=7ab654f6"
import script from "./JustificationList.vue?vue&type=script&lang=js"
export * from "./JustificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports